import Component from '../core/Component'

export default class GalleryOpener extends Component {
    constructor(element) {
        super(element)
    }

    prepare() {
        this.element.addEventListener('click', ::this.handleClick)
    }

    handleClick(event) {
        event.preventDefault()

        const Gallery = Component.getFromElement('product-gallery')

        if (Gallery) {
            let index = parseInt(this.element.dataset.index)

            Gallery.createModal(index)
        }
    }
}